@if (superobjectFilterGroups.length) {
  <mat-form-field appearance="outline" class="superobject-filter-select__form-field">
    <mat-label>{{ 'TRANS__CULTURE_HUB_IMPORTER__SELECT_OBJECT_FILTERS' | translate }}</mat-label>
    <mat-select [formControl]="superobjectFilterGroupControl" multiple>
      @for (group of superobjectFilterGroups; track group) {
        <mat-optgroup [label]="group.name">
          @for (child of group.children; track child) {
            <mat-option [value]="child.value">{{ child.name }}</mat-option>
          }
        </mat-optgroup>
      }
    </mat-select>
  </mat-form-field>
}
